import {activateNotification} from "../utils/notifications-utils";

export class CustomHelper {
    static getUserInitials(firstname, lastname) {
        const firstInitial = firstname?.[0]?.toUpperCase() || "";
        const lastInitial = lastname?.[0]?.toUpperCase() || "";
        return `${firstInitial}${lastInitial}`;
    }
    static formatDateToReadable(date, fallbackDateInString) {
        return date instanceof  Date ? date.toLocaleDateString("en-US", {
            day: "2-digit", month: "long", year: "numeric",
        }) : (fallbackDateInString ?? "");
    }
    static async copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            activateNotification({
                title: "Success",
                body: "Text copied to clipboard.",
            });
        } catch (e) {
            activateNotification({
                type: "Failed",
                body: "Failed to copy to clipboard.",
            });
        }
    }

}